module.exports = __webpack_public_path__ + "media/images/test_img-6071e48143af833b70dc93fd6a4fee25.png";